import { Box, BoxProps, SxProps } from '@mui/material';
import getRatio from '@/utils/getRatio';

type Props = BoxProps & {
  ratio?: '4/3' | '3/4' | '6/4' | '4/6' | '9/16' | '9/21' | '16/9' | '21/9' | '1/1' | 'cover';
  containerStyles?: SxProps;
  children?: any;
};

export default function ResponsiveContainer({
  ratio = '1/1',
  containerStyles,
  children,
  ...other
}: Props) {
  return ratio === 'cover' ? (
    <Box position="relative" sx={{ paddingTop: '100vh' }}>
      <Box
        sx={{
          position: 'absolute',
          top: '43px',
          left: '-16px',
          width: '100vw',
          height: 'calc(100vh - 59px)',
        }}
      >
        {children}
      </Box>
    </Box>
  ) : (
    <Box
      component="span"
      sx={{
        width: 1,
        lineHeight: 1,
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        pt: getRatio(ratio),
        '& .wrapper': {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          lineHeight: 0,
          position: 'absolute',
          backgroundSize: 'cover !important',
        },
        ...containerStyles,
      }}
    >
      <Box className="wrapper" sx={{ width: 1, height: 1 }} {...other}>
        {children}
      </Box>
    </Box>
  );
}
